import { Button, Flex, Icon, Text, Title } from '@bb/elements-web';
import { Modal } from 'components';
import React, { useContext } from 'react';
import styled from 'styled-components';
import BookingTimeSelectContext from './BookingTimeSelectContext';

const RecordShowingModal: React.FC = () => {
  const { recordShowingData, setRecordShowingData } = useContext(
    BookingTimeSelectContext,
  );

  return (
    <Modal
      title={
        <Flex gap="middle" align="center">
          <Icon icon="warningOutlined" size={24} color="warning" />
          <StyledTitle level={3} dataCy="recordShowingModal-title">
            Record Showing
          </StyledTitle>
        </Flex>
      }
      footer={
        <Flex justify="space-around">
          <Button
            dataCy="cancelRecord-btn"
            type="secondary"
            onClick={() =>
              setRecordShowingData(prev => ({ ...prev, isModalOpen: false }))
            }
          >
            Cancel
          </Button>{' '}
          <Button
            dataCy="continueRecord-btn"
            onClick={() => {
              recordShowingData.onOk();
              setRecordShowingData(prev => ({
                ...prev,
                isRecordShowing: true,
                isModalOpen: false,
                shouldShowWarning: false,
                onOk: () => null,
              }));
            }}
          >
            Continue
          </Button>
        </Flex>
      }
      centered
      closable={false}
      open={recordShowingData.isModalOpen}
      data-cy="recordShowing-modal"
    >
      <StyledText size="large">
        You&apos;ve selected a date in the past, would you like to record a past
        showing?
      </StyledText>
    </Modal>
  );
};

const StyledTitle = styled(Title)`
  && {
    margin: 0;
  }
`;

const StyledText = styled(Text)`
  text-align: center;
`;

export default RecordShowingModal;
